export const settlePromises = (promises: Promise<any>[]) => {
    let errors: String[] = []

    let handledPromises = promises.map((promise) => {
        return promise.catch((error) => {
            errors.push(error)
        })
    })

    return new Promise((resolve, reject) => {
        Promise.all(handledPromises).then(() => {
            if (errors.length) {
                reject(errors)
            } else {
                resolve('')
            }
        })
    })
}
